exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".update-fares__token-card[data-v-5b9eff62]{border:1px solid #f5f5f6;margin-bottom:2rem;padding:1rem;box-shadow:0 8px 24px rgba(149,157,165,.2)}.update-fares__token-card .title-class span[data-v-5b9eff62]{padding:.25rem .5rem;font-size:1.25rem;font-weight:500;border:1px solid #54667a;border-radius:1.5rem}.update-fares__token-card .send-token__btn-container[data-v-5b9eff62]{display:flex;justify-content:space-between;align-items:center;border:2px solid #e6e6e7;border-radius:.5rem;margin:3rem auto 1rem;padding:.5rem;font-size:.875rem;font-weight:500;max-width:600px}", ""]);

// exports
